import React, { useEffect, useState } from "react"
import { Title, MainContainer } from "../styles/commonComponents"
import Layout from "../components/layout"
import withApolloClient from "../components/withApolloClient"
import gql from "graphql-tag"
import { useQuery } from "@apollo/react-hooks"
import {
    HorizontalSpacer,
    theme
} from "@omnichannel/ace-b2b-elements"
import styled, { keyframes } from "styled-components"
import { navigate } from "gatsby"
import { inBrowser } from "@omnichannel/ace-b2b-elements"
import {
    getShoppingCartQueryGQL,
} from "../components/gql/cart"
import {
    UserInfoGQL
} from "../components/gql/user"

const Blink = keyframes`
    0%,
    80%,
    100% { box-shadow: 0 2rem 0 -1.3rem ${theme.default.primary}; }
    40% { box-shadow: 0 2rem 0 0 ${theme.default.primary};}
`;

const Dot = styled.div`
        border-radius: 50%;
        width: 2rem;
        height: 2rem;
        animation-fill-mode: both;
        animation: ${Blink} 1.8s infinite ease-in-out;
        margin: .4rem;
    &::before {
        border-radius: 50%;
        width: 2rem;
        height: 2rem;
        animation-fill-mode: both;
        animation: ${Blink} 1.8s infinite ease-in-out;
    }
    &::after {
        border-radius: 50%;
        width: 2rem;
        height: 2rem;
        animation-fill-mode: both;
        animation: ${Blink} 1.8s infinite ease-in-out;
    }
`

const Dot2 = styled(Dot)`
    animation-delay: -0.16s;
    &::after {
        animation-delay: -0.16s;
    }
`
const Dot3 = styled(Dot)`
    animation-delay: -0.32s;
    &::after {
        animation-delay: -0.32s;
    }
`

const ProgressBox = styled.div`
    display: flex;
    justify-content: center;
`

const AuthPage = (props) => {

    const [sid, setSid] = useState(null)

    const { data, loading } = useQuery(
        gql`
          query login($sid: String) {
            login(sid: $sid)
          }
        `,
        {
            variables: { sid: sid },
            skip: sid === null || sid === "",
            fetchPolicy: "network-only",
            awaitRefetchQueries: true,
            refetchQueries: [
              { query: UserInfoGQL},
              { query: getShoppingCartQueryGQL },
            ],
            onCompleted: result => {
                console.log('loginResult::',result)
                if(result && result.login && result.login.accessToken && result.login.refreshToken) {
                    if (inBrowser) {
                        window.localStorage.setItem("access-token", result.login.accessToken)
                        window.localStorage.setItem("refresh-token", result.login.refreshToken)
                        navigate("/")
                    }
                }  else {
                    if (inBrowser) {
                        window.localStorage.removeItem("access-token")
                        window.localStorage.removeItem("refresh-token")
                    }
                }
            },
        }
    )

    useEffect(() => {
        const { search } = props.location ? props.location : { search: "" }
        const sid = search && search.includes("sid=") && search.split("=")[1]
        console.log('did mount search && sid::', search, sid);
        setSid(sid)
        return () => {
            console.log('will unmount');
        }
    }, []);

    let pageContentLoading = (
        <ProgressBox>
            <Dot3></Dot3>
            <Dot2></Dot2>
            <Dot></Dot>
        </ProgressBox>
    )

    let pageContent = (
        <ProgressBox>
            <div style={{ fontSize: "2rem", padding: "2rem 0" }}>Ooops! Authentication failed.</div>
        </ProgressBox>
    )

    return (
        <Layout backgroundColor="#fff" minHeight={"16rem"} {...props} performAuthCheck={false}>
            <MainContainer>
                <HorizontalSpacer />
                <Title style={{ color: "#000" }}>Authenticating</Title>
                {(loading) ? pageContentLoading : (!loading && data && data.login && data.login.accessToken 
                && data.login.refreshToken) ? `` : pageContent}
                <HorizontalSpacer />
            </MainContainer>
        </Layout>
    )
}

export default withApolloClient(AuthPage, {
    client: "b2bClient",
})